import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { CheckboxCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/CheckboxCustomFieldDefinitionDto.ts';
import { ParticipantInputFormWithCustomFields } from '@/features/public/booking/schemas/clientSchema.ts';
import CustomFieldDefinitionDto from '@/features/dashboard/tourCustomFields/types/_CustomFieldDefinitionDto.ts';

export function createEmptyParticipant(
  participantForm: CustomFieldDefinitionDto[],
): ParticipantInputFormWithCustomFields {
  const emptyParticipant: ParticipantInputFormWithCustomFields = {
    firstName: '',
    lastName: '',
    birthDate: undefined,
    customFields: {},
    selectedOptions: {},
  };

  participantForm?.forEach((field) => {
    if (field.type === FieldType.CHECKBOX) {
      const checkboxField = field as CheckboxCustomFieldDefinitionDto;
      emptyParticipant.customFields![field.id] = checkboxField.defaultValue;
    }
  });

  return emptyParticipant;
}
